import { ChangeDetectionStrategy, Component, computed } from '@angular/core';

import { ProviderFeedsBase } from '../shared/provider-feeds-base';
import { ProviderConfig } from '../models/provider.model';
import { Grid } from '../../../shared/components/grid/grid';
import { GridPage } from '../../../shared/components/grid/grid-page';
import { GridCellDirective } from '../../../shared/components/grid/directives/grid-cell.directive';
import { GridColumn, gridColumns } from '../../../shared/components/grid/models/grid.model';
import { LabelBadge } from '../../../shared/components/label-badge/label-badge';

/** Feeds tab for provider types without a dedicated UI: Feed, Tenant, Status. */
@Component({
  selector: 'app-generic-provider-feeds',
  standalone: true,
  imports: [Grid, GridPage, LabelBadge, GridCellDirective],
  template: `
    <!-- No title — the provider shell above the tab strip names the page. -->
    <app-grid-page>
      <app-grid
        [columns]="columns()"
        [data]="feeds()"
        [rowId]="feedId"
        [loading]="isLoading()"
        [totalElements]="feeds().length"
        [totalPages]="1"
        [searchable]="true"
        [primaryAction]="primaryAction()"
        [rowActions]="rowActions()"
        (searchChange)="onSearchChange($event)"
        (rowClick)="onRowClick(asFeed($event))"
        (rowActionClick)="onRowAction($event.actionId, asFeed($event.row))"
        (primaryActionClick)="addFeed()"
      >
        <ng-template gridCell="name" let-row>
          @let feed = asFeed(row);
          <div class="flex min-w-0 flex-col">
            <span class="truncate text-sm font-semibold text-ink-1">{{ feed.name }}</span>
            <span class="truncate text-xs text-ink-3">{{ subtitle(feed) }}</span>
          </div>
        </ng-template>

        <ng-template gridCell="status" let-row>
          @let feed = asFeed(row);
          <span [attr.title]="statusMessage(feed)">
            <app-label-badge [dot]="statusDot(feed)">{{ statusLabel(feed) }}</app-label-badge>
          </span>
        </ng-template>
      </app-grid>
    </app-grid-page>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block h-full min-h-0' },
})
export class GenericProviderFeedsComponent extends ProviderFeedsBase {
  readonly columns = computed<GridColumn<ProviderConfig>[]>(() => {
    this.languageService.current(); // re-evaluate on language switch
    return gridColumns<ProviderConfig>([...this.leadingColumns(), this.statusColumn()]);
  });
}
